'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseButtons = require('@bibliocommons/base-buttons');

var _localizationMessageWithFallback = require('@bibliocommons/localization-message-with-fallback');

var _localizationMessageWithFallback2 = _interopRequireDefault(_localizationMessageWithFallback);

var _utilsBrowser = require('@bibliocommons/utils-browser');

var _baseCheckbox = require('@bibliocommons/base-checkbox');

var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);

require('../styles/LoginForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var REMEMBER_ME_COOKIE = 'remember_me';

var LoginForm = function (_BcReactComponent) {
  _inherits(LoginForm, _BcReactComponent);

  function LoginForm(props) {
    _classCallCheck(this, LoginForm);

    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));

    _this.state = {
      username: (0, _utilsBrowser.getCookie)(REMEMBER_ME_COOKIE) || '',
      password: '',
      rememberMe: !!(0, _utilsBrowser.getCookie)(REMEMBER_ME_COOKIE)
    };
    _this.bindAll('handleSubmit', 'handleUsernameChange', 'handlePasswordChange', 'handleRememberMeChange', 'onFocus');
    return _this;
  }

  _createClass(LoginForm, [{
    key: 'handleUsernameChange',
    value: function handleUsernameChange(e) {
      this.setState({ username: e.target.value });
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      if (this._input === document.activeElement) {
        document.body.scrollTop = 0;
      }
    }
  }, {
    key: 'handlePasswordChange',
    value: function handlePasswordChange(e) {
      this.setState({ password: e.target.value });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();

      // Store cookie if rememberMe is true, otherwise delete it by setting expiration to a time in the past
      var expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + (this.state.rememberMe ? 10 : -10));
      (0, _utilsBrowser.setCookie)(REMEMBER_ME_COOKIE, this.state.username, { expires: expiryDate, path: '/' });

      this.props.login(this.state.username, this.state.password);
    }
  }, {
    key: 'handleRememberMeChange',
    value: function handleRememberMeChange(checked) {
      this.setState({
        rememberMe: checked
      });
    }
  }, {
    key: 'renderLoginError',
    value: function renderLoginError() {
      if (!this.props.loginErrorMessage) return false;

      return _react2.default.createElement(
        _baseAlerts.AlertFailure,
        null,
        _react2.default.createElement(
          _localizationMessageWithFallback2.default,
          { id: this.props.loginErrorMessage },
          _react2.default.createElement(
            'span',
            null,
            this.props.loginErrorMessage
          )
        )
      );
    }
  }, {
    key: 'renderGetCardLink',
    value: function renderGetCardLink() {
      var getCardLink = this.props.getCardLink;


      if (getCardLink) {
        return _react2.default.createElement(
          'div',
          { className: 'get-card-link' },
          _react2.default.createElement(
            'a',
            { href: getCardLink, 'data-test-id': 'get-card-link' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_get_a_card' })
          )
        );
      }

      return null;
    }
  }, {
    key: 'getPasswordType',
    value: function getPasswordType() {
      return this.props.numericPasswordRequired ? 'pin' : 'password';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-login-form', ref: function ref(el) {
            _this2._root = el;
          } },
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit },
          this.renderLoginError(),
          _react2.default.createElement(
            'div',
            { className: 'cp-login-form-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'login-username' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'form_label_username_barcode' })
              ),
              _react2.default.createElement('input', {
                type: 'text',
                name: 'login-username',
                id: 'login-username',
                ref: function ref(el) {
                  return _this2._input = el;
                },
                className: 'form-control username',
                onFocus: this.onFocus,
                value: this.state.username,
                onChange: this.handleUsernameChange })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'login-password', 'data-test-id': 'loginform-password-label' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'form_label_' + this.getPasswordType() })
              ),
              _react2.default.createElement('input', {
                type: 'password',
                name: 'login-password',
                id: 'login-password',
                className: 'form-control password',
                value: this.state.password,
                onChange: this.handlePasswordChange })
            ),
            _react2.default.createElement(_baseCheckbox2.default, {
              id: 'remember-me-on-device',
              inline: true,
              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_remember_credentials_device' }),
              checked: this.state.rememberMe,
              labelTestId: 'remember-me',
              handleChange: this.handleRememberMeChange }),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'a',
                { href: '/user/forgot' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_forgot_' + this.getPasswordType() })
              )
            ),
            _react2.default.createElement(
              _baseButtons.PrimaryButton,
              {
                type: 'submit',
                isLoading: this.props.loading },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_submit' })
            ),
            _react2.default.createElement(
              _baseButtons.Button,
              {
                type: 'reset',
                handleClick: this.props.handleClose,
                className: 'btn-link' },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
            ),
            this.renderGetCardLink()
          )
        )
      );
    }
  }]);

  return LoginForm;
}(_baseBcReactComponent2.default);

LoginForm.propTypes = {
  handleClose: _react.PropTypes.func,
  loading: _react.PropTypes.bool,
  login: _react.PropTypes.func.isRequired,
  numericPasswordRequired: _react.PropTypes.bool,
  loginErrorMessage: _react.PropTypes.string,
  getCardLink: _react.PropTypes.string
};

exports.default = LoginForm;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login-form/components/LoginForm.component.js
// module id = 1426
// module chunks = 1